import AlbumItem from './AlbumItem';

export default AlbumItem;
